export const createWebSocket = (
  url: string,
  WebSocketImplementation: typeof WebSocket,
) => {
  return new WebSocketImplementation(url);
};
